module.exports = __webpack_public_path__ + "img/2025-07-21a_1.259899f5.jpg";